@if (breadcrumbs && breadcrumbs.length) {
  <ul class="route-breadcrumbs">
    @for (crumb of breadcrumbs; track trackByIndex($index, crumb); let last = $last) {
      <li [ngClass]="{ home: isHome }">
        @if (crumb.route !== null && !last) {
          <span class="navigable-route" (click)="onRouteSelected(crumb.route)" [attr.data-testid]="'link-route-' + crumb.label | slugify">
            {{ crumb.label }}
          </span>
        }
        @if (crumb.route === null || last) {
          <span title="{{ crumb.label }}" class="non-navigable-route" [class.current-route]="last">
            {{ crumb.label }}
          </span>
        }
        @if (!last) {
          <span class="segment-divider">/</span>
        }
      </li>
    }
  </ul>
}
